<template>
  <div class="download">
    <div class="bg"></div>
    <div class="download-content" v-if="appDetail">
      <div class="app-info">
        <div class="app-logo">
          <img :src="appDetail.icon_url" alt="">
        </div>
        <h3 class="app-name">{{ appDetail.app_name }}</h3>
        <p class="app-version">v{{ appDetail.get_version_data.version_number }}</p>
      </div>
      <div class="download-code">
        <img :src="qrcode" alt="">
      </div>
      <div class="download-btn">
        <el-button type="primary" @click="download">点击立即下载<i class="el-icon-download el-icon--right"></i></el-button>
      </div>
      <div class="update-log">
        <h3 class="update-title">更新日志</h3>
        <div class="update-desc" v-html="versionDesc"></div>
      </div>
    </div>
    <div class="wechat-download-tips" v-if="wechatTipsVisible">
      <img :src="require('@/assets/images/browser-open.png')" alt="">
    </div>
  </div>
</template>
<script>

import qrcode from 'qrcode';

export default {
  data() {
    return {
      id: this.$route.query.id,
      appDetail: null,
      qrcode: null,
      wechatTipsVisible: false,
      versionDesc: ''
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await this.$api.downloadAppDetail({
        id: this.id,
      });
      if(res.data.code == 0) {
        this.appDetail = res.data.data;
        const generateQR = await qrcode.toDataURL(window.location.href);
        this.qrcode = generateQR;
        if(this.appDetail.get_version_data) {
          let str = this.appDetail.get_version_data.version_desc.toString();
          this.versionDesc = str.replace('\n', '<br />');
        }
      } else {
        this.$message.error(res.data.msg)
      }
    },
    download() {
      if(this.isIOS()) {
        alert('ios请前往App Stroe下载');
      } else if(this.isWechat()) {
        this.wechatTipsVisible = true;
      } else {
        const src = this.appDetail.get_version_data.download_url;
        const form = document.createElement('form');
        form.action = src;
        document.getElementsByTagName('body')[0].appendChild(form);
        form.submit();
      }
    },
    isWechat(){
      const ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return true;
      } else{
        return false;
      }
    },
    isIOS(){
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isiOS;
    }
  }
}
</script>
<style lang="scss" scoped>
.download {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
  position: relative;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .bg {
    width: 150%;
    min-width: 1440px;
    height: 250px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    background: #409EFF;
    border-radius: 0 0 100% 100%;
    overflow: hidden;
  }

  .download-content {
    margin: 0 auto;
    width: 410px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -70px;

    .app-logo {
      width: 120px;
      height: 120px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
      border-radius: 8px;
      overflow: hidden;
      background: #fff;
      margin: 0 auto;
    }

    .app-name {
      text-align: center;
      font-size: 24px;
      padding-top: 20px;
    }

    .app-version {
      text-align: center;
      color: #999;
      padding-top: 10px;
    }

    .download-code {
      width: 220px;
      height: 220px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
      border-radius: 8px;
      margin-top: 50px;
      overflow: hidden;
    }

    .download-btn {
      margin-top: 40px;
    }
  }

  .update-log {
    width: 100%;
    margin-top: 50px;
    padding: 0 20px;
    box-sizing: border-box;

    .update-desc {
      padding-top: 10px;
      color: #666;
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

.wechat-download-tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);

  img {
    width: 100%;
  }
}

@media (max-width: 414px) {
  .download {
    .download-content {
      width: 100%;
    }
  }
}
</style>